// Static metadata so SEO/share tags render instantly (generated from backend/insights_seed.py)
export const INSIGHTS_META = {
  "the-future-of-transportation-is-connected": {
    "title": "The Future of Transportation Is Connected: From GPS Tracking to Intelligent Fleet Operations",
    "excerpt": "Fleet management is moving from a tracking system to an operational intelligence layer. Here is how we got here — and where it goes next.",
    "category": "Thought Leadership",
    "read_time": "4 min read",
    "published_at": "2026-06-20",
    "cover": "/images/insights/connected-future.webp"
  },
  "ai-in-transportation-10-use-cases": {
    "title": "AI in Transportation: 10 Use Cases That Are Moving From Hype to Reality",
    "excerpt": "Forget generic predictions. These are the AI applications transportation operators are actually deploying today — and the question that comes next.",
    "category": "AI & Analytics",
    "read_time": "5 min read",
    "published_at": "2026-06-12",
    "cover": "/images/insights/ai-use-cases.webp"
  },
  "beyond-gps-how-iot-is-changing-fleet-management": {
    "title": "Beyond GPS: How IoT Is Changing the Way Businesses Manage Vehicles, Drivers and Assets",
    "excerpt": "GPS tells you where something is. IoT tells you how it is being used, how it is performing and whether it is earning its keep.",
    "category": "IoT & Telematics",
    "read_time": "4 min read",
    "published_at": "2026-06-05",
    "cover": "/images/insights/iot-beyond-gps.webp"
  },
  "smart-school-transport-intelligent-bus": {
    "title": "Smart School Transport: What Happens When Every Bus Becomes an Intelligent Vehicle?",
    "excerpt": "The school bus of the future won't just track children. It will understand what is happening inside and around the bus.",
    "category": "School Transport",
    "read_time": "4 min read",
    "published_at": "2026-05-28",
    "cover": "/images/insights/smart-school.webp"
  },
  "from-order-to-doorstep-ai-last-mile-delivery": {
    "title": "From Order to Doorstep: How AI and Automation Are Reshaping Last-Mile Delivery",
    "excerpt": "Follow the delivery journey step by step — and see where automation and AI are turning delivery software into an AI delivery control tower.",
    "category": "Logistics Automation",
    "read_time": "5 min read",
    "published_at": "2026-05-15",
    "cover": "/images/insights/last-mile.webp"
  }
};

// Old placeholder article slugs → closest current article (301-style client redirects for Google)
export const INSIGHT_REDIRECTS = {
  "designing-a-school-transport-technology-stack": "smart-school-transport-intelligent-bus",
  "what-is-a-transportation-technology-systems-integrator": "the-future-of-transportation-is-connected",
  "integrating-fleet-data-with-erp-and-ecommerce": "beyond-gps-how-iot-is-changing-fleet-management",
  "video-telematics-and-ai-in-commercial-fleets": "ai-in-transportation-10-use-cases",
};
